import { Service, BaseService } from "@/core/auto";

@Service('/api/external/')
export default class External extends BaseService{
	pageShow(data) {
		return this.request({
            showError: false,
            data: data,
			url: "/pageShow",
			method: "POST"
		})
	}
}